import { Row, Col } from 'antd';
import { FormType } from 'enums/FieldTypeEnums';
import React, { FC, useContext, useState } from 'react';
import FieldsRow from 'shared/components/FieldsRow';
import { GetFormData } from '../commodityDistributionLayoutData';
import { UseFieldArrayRemove, useFormContext } from 'react-hook-form';
import LocationModal, {
  generateAddressLabel,
} from 'views/Scope3/Category4&9/LocationModal';
import { Address } from 'models/Address/address.model';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';

interface EndMarketLocationFieldsProps {
  index: number;
  remove: UseFieldArrayRemove;
  isDisabled: boolean;
}

const EndMarketLocationFields: FC<EndMarketLocationFieldsProps> = props => {
  const { index, remove, isDisabled } = props;
  const { setValue, watch, trigger } = useFormContext();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const [selectedIndex, setSelectedIndex] = useState<number>();
  const [openLocationModal, setOpenLocationModal] = useState<boolean>(false);
  const showLocationModal = (index: number) => {
    setSelectedIndex(index);
    toggleLocationModal();
  };
  const routes = watch('routes');
  const formData = GetFormData({
    index,
    remove,
    toggleLocationModal: showLocationModal,
    routesLength: routes?.length,
    fetchData,
    isDisabled,
  });

  const toggleLocationModal = () => setOpenLocationModal(prev => !prev);
  const handleAddAddress = async (address: Address) => {
    setValue(`routes.${selectedIndex}.address`, address);
    const label = generateAddressLabel(address);
    setValue(`routes.${selectedIndex}.addressLabel`, label, {
      shouldTouch: true,
      shouldValidate: true,
    });
    await trigger('routes');
    toggleLocationModal();
  };
  const addressItem = watch(`routes.${selectedIndex}.address`);
  return (
    <Row>
      <Col span={24}>
        <FieldsRow {...formData} formType={FormType.REACT_HOOK_FORMS} />
      </Col>
      <LocationModal
        showModal={openLocationModal}
        onCancel={toggleLocationModal}
        handleSubmit={handleAddAddress}
        initialValue={addressItem}
      />
    </Row>
  );
};

export default EndMarketLocationFields;
